import { INonNumericReleaseItem } from '@planning/rt-stores/nnrOrder/NnrOrderItem'
import { INumericReleaseItem } from '@planning/rt-stores/numericRelease/NumericReleaseItem'
import { TFnType } from '@tolgee/react'

export const getReleaseShippingLineInfo = (
  releaseItem: INumericReleaseItem | INonNumericReleaseItem,
  t: TFnType,
) => {
  const item = releaseItem

  let name = item.operator?.data.name
  let shortName = item.operator?.data.shortName

  if (!name) {
    if ('shippingLineName' in item.data) {
      name = item.data.shippingLineName
      shortName = item.data.shippingLineShortName
    } else if ('shippingLine' in item.data) {
      name = item.data.shippingLine
    } else {
      name = t('unknownOperator', 'Unknown operator')
    }
  }

  return { name, shortName }
}
